import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import { useParams } from 'react-router-dom';
import MainLayout from '../../layouts/MainLayout';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faHandsHelping, faMedal, faHands, faAward, faTrophy, faCoins, faExchangeAlt, faCogs, faRankingStar, faCertificate, faStar } from '@fortawesome/free-solid-svg-icons';
import './ApplauseHubHome.css';
import applausehubimage from '../../assets/pageimages/ApplauseHub.webp';

function ApplauseHubKidsHome() {

  return (
    <MainLayout>
      <div className="min-h-full py-8 bg-gradient-to-r from-teal-500 via-green-500 to-blue-500 mt-12">
        <h2 className='text-2xl font-bold text-white text-center mb-6'>Applause Hub</h2>
        <div className="min-h-[50vh] px-4">
          {/* <div className="flex justify-center mb-6">
            <img src={applausehubimage} alt="Applause Hub Image" className="rounded-lg shadow-lg w-full max-w-md" />
          </div>           */}
          {/* <div className="flex flex-col sm:flex-row justify-center items-center mb-6 rounded-lg shadow-lg bg-gradient-to-r from-gray-400 via-purple-300 to-purple-600 p-6 transition-transform transform hover:scale-105 space-y-4 sm:space-y-0 sm:space-x-8"> */}
            <div className="flex justify-center mb-4 sm:mb-0">
              <img
                style={{ width: "200px", height: "auto" }}
                src={applausehubimage}
                alt="Applause Hub Image"
                className="rounded-lg shadow-lg w-24 sm:w-32 lg:w-40 max-w-full"
              />
            </div>
          {/* </div> */}

          <div className="bg-gradient-to-r from-purple-400 via-blue-400 to-orange-400 mb-2 p-4 rounded-lg shadow-lg transition-transform transform hover:scale-105 flex flex-col sm:flex-row justify-around items-center space-y-4 sm:space-y-0 sm:space-x-8 ml-6 mr-6 mt-2">
            <CardLink to="/i-applauded" icon={faHandsHelping} text="I Applauded" />
            <CardLink to="/self-applause" icon={faHands} text="Self Applause" />
            <CardLink to="/applause-for-me" icon={faMedal} text="Applause For Me" />
          </div>
        </div>
      </div>
    </MainLayout>
  );
};

// CardLink Component
const CardLink = ({ to, icon, text }) => (
  <div className="bg-white p-2 rounded-lg shadow-lg transition-transform transform hover:scale-105">
    <Link to={to} className="flex items-center text-sm sm:text-m text-gray-700 hover:text-gray-900">
      <FontAwesomeIcon icon={icon} className="text-xl sm:text-xl mr-3" />
      {text}
    </Link>
  </div>
);

// CardLink Component
const CardNoLink = ({ to, icon, text }) => (
  <div className="bg-gray-300 p-2 rounded-lg shadow-lg transition-transform transform hover:scale-105">
    <Link to={to} className="flex items-center text-sm sm:text-m text-gray-700 hover:text-gray-900">
      <FontAwesomeIcon icon={icon} className="text-sm sm:text-m mr-3" />
      {text}
    </Link>
  </div>
);

export default ApplauseHubKidsHome;
